import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Progress } from 'components/ui/Progress';
import { FIRST_STEP } from '../model';

interface ProgressBarFormProps {
  step: number;
  totalSteps: number;
  progress: number;
  onPreviousStep: () => void;
  isProfileSetup?: boolean;
}

export const ProgressBarForm = ({
  step,
  totalSteps,
  progress,
  isProfileSetup,
  onPreviousStep,
}: ProgressBarFormProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);

  return (
    <div className="space-y-2">
      {!isProfileSetup && step > FIRST_STEP && (
        <Button
          variant="ghost"
          size="lg"
          onClick={onPreviousStep}
          className="absolute top-4 left-4 h-8 w-8 hover:bg-transparent"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
      )}
      <p className="text-sm text-gray-600">{t('Register.progress', { step, total: totalSteps })}</p>
      <Progress value={progress} className="h-2" />
    </div>
  );
};
